export default "__VITE_PUBLIC_ASSET__9956e918__"